import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

type SkeletonProps = {
  height: string;
  width: string;
};

export const SkeletonComponent = ({ height, width }: SkeletonProps) => {
  return <Skeleton height={height} width={width}></Skeleton>;
};
